export const SET_CHAT_CONTENT = 'SET_CHAT_CONTENT';
export const MAKE_USER_ADMIN = 'MAKE_USER_ADMIN';
export const MAKE_USER_ADMIN_FAILED = 'MAKE_USER_ADMIN_FAILED';
export const MAKE_USER_ADMIN_SUCCESS = 'MAKE_USER_ADMIN_SUCCESS';
export const REMOVE_ADMIN = 'REMOVE_ADMIN';
export const REMOVE_ADMIN_FAILED = 'REMOVE_ADMIN_FAILED';
export const REMOVE_ADMIN_SUCCESS = 'REMOVE_ADMIN_SUCCESS';
export const BLOCK_DIALOG = 'BLOCK_DIALOG';
export const BLOCK_DIALOG_FAILED = 'BLOCK_DIALOG_FAILED';
export const BLOCK_DIALOG_SUCCESS = 'BLOCK_DIALOG_SUCCESS';
export const UNBLOCK_DIALOG = 'UNBLOCK_DIALOG';
export const UNBLOCK_DIALOG_FAILED = 'UNBLOCK_DIALOG_FAILED';
export const UNBLOCK_DIALOG_SUCCESS = 'UNBLOCK_DIALOG_SUCCESS';

export const OPEN_DIALOG_WITH_USER = 'OPEN_DIALOG_WITH_USER';
export const OPEN_EXISTING_DIALOG = 'OPEN_EXISTING_DIALOG';
export const GET_DIALOG_INFO_BY_PEER = 'GET_DIALOG_INFO_BY_PEER';
export const GET_DIALOG_INFO_BY_PEER_SUCCESS = 'GET_DIALOG_INFO_BY_PEER_SUCCESS';
export const GET_DIALOG_INFO_BY_PEER_FAILED = 'GET_DIALOG_INFO_BY_PEER_FAILED';
export const OPEN_PENDING_CHAT = 'OPEN_PENDING_CHAT';

export const SET_SELECTION_MODE = 'SET_SELECTION_MODE';
export const SET_SELECTED_MESSAGES = 'SET_SELECTED_MESSAGES';

export const DELETE_MESSAGES = 'DELETE_MESSAGES';
export const DELETE_MESSAGES_SUCCESS = 'DELETE_MESSAGES_SUCCESS';
export const DELETE_MESSAGES_FAILED = 'DELETE_MESSAGES_FAILED';

export const SEARCH_DIALOGS = 'SEARCH_DIALOGS';
export const SEARCH_DIALOGS_SUCCESS = 'SEARCH_DIALOGS_SUCCESS';
export const SEARCH_DIALOGS_FAILED = 'SEARCH_DIALOGS_FAILED';

export const SEARCH_GLOBAL_CHAT = 'SEARCH_GLOBAL_CHAT';
export const SEARCH_GLOBAL_CHAT_SUCCESS = 'SEARCH_GLOBAL_CHAT_SUCCESS';
export const SEARCH_GLOBAL_CHAT_FAILED = 'SEARCH_GLOBAL_CHAT_FAILED';

export const SET_ANSWER_MESSAGE = 'SET_ANSWER_MESSAGE';

export const CREATE_POLL = 'CREATE_POLL';
export const CREATE_POLL_FAILED = 'CREATE_POLL_FAILED';
export const CREATE_POLL_SUCCESS = 'CREATE_POLL_SUCCESS';

export const SUBMIT_POLL_ANSWER = 'SUBMIT_POLL_ANSWER';
export const SUBMIT_POLL_ANSWER_FAILED = 'SUBMIT_POLL_ANSWER_FAILED';
export const SUBMIT_POLL_ANSWER_SUCCESS = 'SUBMIT_POLL_ANSWER_SUCCESS';

export const STOP_POLL = 'STOP_POLL';
export const STOP_POLL_FAILED = 'STOP_POLL_FAILED';
export const STOP_POLL_SUCCESS = 'STOP_POLL_SUCCESS';

export const GET_POLL = 'GET_POLL';
export const GET_POLL_FAILED = 'GET_POLL_FAILED';
export const GET_POLL_SUCCESS = 'GET_POLL_SUCCESS';

export const GET_POLL_ANSWER_USERS = 'GET_POLL_ANSWER_USERS';
export const GET_POLL_ANSWER_USERS_FAILED = 'GET_POLL_ANSWER_USERS_FAILED';
export const GET_POLL_ANSWER_USERS_SUCCESS = 'GET_POLL_ANSWER_USERS_SUCCESS';

export const CLEAR_POLL_INFO = 'CLEAR_POLL_INFO';
export const CLEAR_POLL_ACTION_ERROR = 'CLEAR_POLL_ACTION_ERROR';

export const OPEN_CREATE_GROUP_MODAL = 'OPEN_CREATE_GROUP_MODAL';

export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAILED = 'GET_USERS_LIST_FAILED';
export const CLEAR_CHATS = 'CLEAR_CHATS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_POLLS = 'CLEAR_POLLS';

export const FETCH_CHATS = 'FETCH_CHATS';
export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAILED = 'FETCH_CHATS_FAILED';
export const GET_CHAT_INFO = 'GET_CHAT_INFO';
export const GET_CHAT_INFO_SUCCESS = 'GET_CHAT_INFO_SUCCESS';
export const GET_CHAT_INFO_FAILED = 'GET_CHAT_INFO_FAILED';
export const SELECT_CHAT = 'SELECT_CHAT';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const CREATE_GROUP = 'CREATE_GROUP';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';
export const CREATE_GROUP_FAILED = 'CREATE_GROUP_FAILED';

export const PIN_CHAT = 'PIN_CHAT';
export const PIN_CHAT_SUCCESS = 'PIN_CHAT_SUCCESS';
export const PIN_CHAT_FAILED = 'PIN_CHAT_FAILED';
export const UNPIN_CHAT = 'UNPIN_CHAT';
export const UNPIN_CHAT_SUCCESS = 'UNPIN_CHAT_SUCCESS';
export const UNPIN_CHAT_FAILED = 'UNPIN_CHAT_FAILED';

export const ENABLE_NOTIFICATIONS = 'ENABLE_NOTIFICATIONS';
export const ENABLE_NOTIFICATIONS_SUCCESS = 'ENABLE_NOTIFICATIONS_SUCCESS';
export const ENABLE_NOTIFICATIONS_FAILED = 'ENABLE_NOTIFICATIONS_FAILED';
export const DISABLE_NOTIFICATIONS = 'DISABLE_NOTIFICATIONS';
export const DISABLE_NOTIFICATIONS_SUCCESS = 'DISABLE_NOTIFICATIONS_SUCCESS';
export const DISABLE_NOTIFICATIONS_FAILED = 'DISABLE_NOTIFICATIONS_FAILED';

export const INCREASE_MESSAGE_COUNT = 'INCREASE_MESSAGE_COUNT';
export const DECREASE_MESSAGE_COUNT = 'DECREASE_MESSAGE_COUNT';
export const RESET_SEARCH_RESULT = 'RESET_SEARCH_RESULT';
export const POST_WEBSOCKET_MESSAGE = 'POST_WEBSOCKET_MESSAGE';
export const RECEIVE_WEBSOCKET_MESSAGE = 'RECEIVE_WEBSOCKET_MESSAGE';

export const DELETE_CHAT = 'DELETE_CHAT';
export const DELETE_CHAT_SUCCESS = 'DELETE_CHAT_SUCCESS';
export const DELETE_CHAT_FAILED = 'DELETE_CHAT_FAILED';

export const DELETE_GROUP_CHAT = 'DELETE_GROUP_CHAT';
export const DELETE_GROUP_CHAT_SUCCESS = 'DELETE_GROUP_CHAT_SUCCESS';
export const DELETE_GROUP_CHAT_FAILED = 'DELETE_GROUP_CHAT_FAILED';

export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const UPDATE_MESSAGE_SUCCESS = 'UPDATE_MESSAGE_SUCCESS';
export const UPDATE_MESSAGE_FAILED = 'UPDATE_MESSAGE_FAILED';
export const SET_EDITABLE_MESSAGE = 'SET_EDITABLE_MESSAGE';
export const CHANGE_EDIT_MESSAGE_MODE = 'CHANGE_EDIT_MESSAGE_MODE';

export const SET_GROUP_USER_LIST = 'SET_GROUP_USER_LIST';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';
export const UPDATE_GROUP_FAILED = 'UPDATE_GROUP_FAILED';
export const INVITE_USER = 'INVITE_USER';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILED = 'INVITE_USER_FAILED';
export const LEAVE_GROUP = 'LEAVE_GROUP';
export const LEAVE_GROUP_SUCCESS = 'LEAVE_GROUP_SUCCESS';
export const LEAVE_GROUP_FAILED = 'LEAVE_GROUP_FAILED';

export const CLEAR_DIALOG_INFO = 'CLEAR_DIALOG_INFO';
export const GET_DIALOG_INFO = 'GET_DIALOG_INFO';
export const GET_DIALOG_INFO_SUCCESS = 'GET_DIALOG_INFO_SUCCESS';
export const GET_DIALOG_INFO_FAILED = 'GET_DIALOG_INFO_FAILED';
export const GET_UPDATED_CHAT_INFO = 'GET_UPDATED_CHAT_INFO';
export const GET_UPDATED_CHAT_INFO_SUCCESS = 'GET_UPDATED_CHAT_INFO_SUCCESS';
export const GET_UPDATED_CHAT_INFO_FAILED = 'GET_UPDATED_CHAT_INFO_FAILED';
export const FETCH_LAST_CHAT = 'FETCH_LAST_CHAT';

export const GET_USERS_STATUS = 'GET_USERS_STATUS';
export const GET_USERS_STATUS_SUCCESS = 'GET_USERS_STATUS_SUCCESS';
export const GET_USERS_STATUS_FAILED = 'GET_USERS_STATUS_FAILED';
export const ADD_STATUS_TO_CHATS = 'ADD_STATUS_TO_CHATS';

export const READ_MESSAGES = 'READ_MESSAGES';
export const READ_MESSAGES_SUCCESS = 'READ_MESSAGES_SUCCESS';
export const READ_MESSAGES_FAILED = 'READ_MESSAGES_FAILED';
export const CHANGE_LOAD_MESSAGE_STATUS = 'CHANGE_LOAD_MESSAGE_STATUS';

export const SEARCH_IN_DIALOG = 'SEARCH_IN_DIALOG';
export const SEARCH_IN_DIALOG_SUCCESS = 'SEARCH_IN_DIALOG_SUCCESS';
export const SEARCH_IN_DIALOG_FAILED = 'SEARCH_IN_DIALOG_FAILED';
export const CLEAR_SEARCH_IN_DIALOG = 'CLEAR_SEARCH_IN_DIALOG';
export const NAVIGATE_TO_CHAT_MESSAGE_REQUEST = 'NAVIGATE_TO_CHAT_MESSAGE_REQUEST';

export const UPLOAD_FILE_FAILED = 'UPLOAD_FILE_FAILED';
export const CHANGE_UPLOAD_FILES = 'CHANGE_UPLOAD_FILES';
export const UPLOAD_ATTACHED_FILE = 'UPLOAD_ATTACHED_FILE';
export const UPLOAD_ATTACHED_FILE_SUCCESS = 'UPLOAD_ATTACHED_FILE_SUCCESS';
export const UPLOAD_GROUP_AVATAR = 'UPLOAD_GROUP_AVATAR';
export const UPLOAD_GROUP_AVATAR_SUCCESS = 'UPLOAD_GROUP_AVATAR_SUCCESS';
export const REMOVE_UPLOAD_GROUP_AVATAR = 'REMOVE_UPLOAD_GROUP_AVATAR';

export const CLEAR_NOTIFICATION_INFO = 'CLEAR_NOTIFICATION_INFO';
